var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"debug-bar"},[_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.env))])]),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.apiUrl))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }